export class AIRMasterDTO {
  position: string;
  templateId: string;
  templateName: string;
  processCount: string;
  airItemsCount: string;
  createdOn: string;
  createdBy: string;
  modifiedOn: string;
  modifiedBy: string;
  status: string;
  auditFirmName: string;
  auditFirmId: string;
  isActive: string;
  departmentName: string;
  airItemName: string;
  isAttachmentRequired: string;
  airId: string;
  departmentId: string;
  statusId: string;
  clientId: string;
  isOpen: boolean = false;
  businessVerticalId: string;
  businessVerticalName: string;
  financialYearId: string;
  financialYearName: string;
  airTemplateNameShort: string;
  auditAreaId: any;
}
